package com.exura.features.plandefinition.data.remote.dto.series

import com.exura.features.plandefinition.domain.model.series.HourOfDay
import com.exura.features.plandefinition.domain.model.series.SeriesSpawnType
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * DTO for SimplePersistentSeries.
 * Extends BaseAnchoredSeriesDto for Firebase storage compatibility.
 */
@Serializable
@SerialName("persistent_series")
data class SimplePersistentSeriesDto(
    override val name: String,
    override val description: String,
    override val seriesType: SeriesSpawnType = SeriesSpawnType.PERSISTENT,
    override val durationInDays: Int? = null,
    val relativeDay: Int,
    val startHourOfDay: HourOfDay? = null,
    val icon: String? = null,
    val durationDays: Int? = null,
    val durationInMinutes: Int? = null,
    override val imageUrl: String? = null,
) : BaseSeriesDto()
